import { waitFor } from '@dinosband/dbi-utils'
import { DataCenter_StoreType } from './data-center-store-type'

export abstract class DataCenter_ProxyType <K, T> extends DataCenter_StoreType<K, T> {

  _retrievings: K[] = []

  cleanup () {
    super.cleanup()
    this._retrievings = []
  }

  async read (key: K, update?: boolean): Promise<T | undefined> {
    let data = this.get(key)
    if (data == null || update) {
      if (this._retrievings.includes(key)) {
        await waitFor(() => this.has(key), 5_000)
      } else {
        this._retrievings.push(key)
        await this._query(key)
        this._retrievings = this._retrievings.filter((i) => i !== key)
      }
      data = this.get(key)
    }
    return data
  }

  protected async query (key: K): Promise<T | undefined> {
    // abstract
    return undefined
  }

  protected async _query (key: K) {
    try {
      const result = await this.query(key)
      if (result != null) {
        this.set(key, result)
      }
    } catch (e) {
      console.error(e)
    }
  }
}